<template>
    <div class="main">
        <!--Filter-->
        <v-container fluid class="pa-0">
            <v-card class="d-flex ml-2 pt-2 pb-0 flex-row" outlined>
                <v-form class="slim">
                    <v-container class="d-flex ml-2 pt-2 flex-row flex-wrap">
                        <v-text-field class="pr-2 mx-240" v-model="filter.fldTLogin" label="Usuario" v-on:keyup.enter="loadData" outlined clearable dense></v-text-field>

                        <v-text-field class="pr-2 mx-240" v-model="filter.fldTEmail" label="Email" v-on:keyup.enter="loadData" outlined clearable dense></v-text-field>

                        <v-autocomplete class="pr-2 mx-240" v-model="filter.fkNTipoUsuario" :items="userTypes" item-text="fldTNombre" item-value="idNTipoUsuario" 
                                        label="Tipo de Usuario" v-on:keyup.enter="loadData" outlined clearable dense></v-autocomplete>

                        <v-row>
                            <v-checkbox class="ml-4 mt-1" v-model="filter.fldBActivo" label="Activo" outlined dense :indeterminate="filter.fldBActivo == null" 
                                        v-on:keyup.enter="loadData" @change="chkfldBActivoFueTrue"></v-checkbox>
                        </v-row>

                        <v-card-actions class="btns-float">
                            <v-btn color="grey" small @click="clearFilter">Limpiar</v-btn>

                            <v-btn color="accent" dark small @click="loadData">Filtrar</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-form>
            </v-card>
        </v-container>

        <!--Buttons-->
        <v-container class="pb-3 ml-1 mb-3">
            <v-btn color="accent" small dark @click="addUser">Agregar Usuario</v-btn>
            <v-btn small color="accent" dark class="ml-5" @click="exportPDF">
                PDF <v-icon dark right>mdi-adobe-acrobat</v-icon>
            </v-btn>
            <v-btn small color="accent" class="ml-5" dark @click="exportExcel">
                Excel <v-icon dark right>mdi-file-excel-outline</v-icon>
            </v-btn>
        </v-container>

        <!--NuevoForm-->
        <v-dialog persistent v-model="nuevoForm" max-width="510">
            <v-card class="mx-auto">
                <v-toolbar color="blue" dark>
                    <v-toolbar-title>Agregar Usuario</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-form ref="formularioNuevo" class="slim">
                    <v-container class="d-flex pt-6 flex-row flex-wrap">
                        <v-text-field class="pr-3 mx-240" v-model="user.fldTNombre" label="Nombre" outlined :rules="nameRules" dense></v-text-field>
                        <v-text-field class="pr-3 mx-240" v-model="user.fldTLogin" label="Usuario" outlined :rules="loginRules" dense></v-text-field>
                        <v-text-field class="pr-3 mx-240" v-model="user.fldTEmail" label="Email" :rules="emailRules" outlined dense></v-text-field>
                        <v-text-field class="pr-3 mx-240" outlined dense label="Password" type="password" :rules="passwordRules" v-model="user.fldTPassword"></v-text-field>
                        <v-autocomplete class="pr-3 mx-240" v-model="user.fkNTipoUsuario" :items="userTypes" item-text="fldTNombre" item-value="idNTipoUsuario" 
                                        label="Tipo de Usuario" clearable outlined :rules="usertypeRules" dense></v-autocomplete>
                        <!--Al momento de dar de alta creamos la relacion empresa-usuario--->
                        <v-autocomplete class="pr-3 mx-240" v-model="user.idNEmpresa" :items="companies" item-text="fldTNombre" item-value="idNEmpresa" 
                                        label="Empresa" clearable outlined :rules="companyRules" dense></v-autocomplete>
                        <v-row class="ml-5 mt-2 mb-5">
                            <v-checkbox class="pr-3 mt-n2" label="Activo" v-model="user.fldBActivo" outlined dense></v-checkbox>
                        </v-row>
                        <v-card-actions class="btns-float px-6 pb-6">
                            <v-btn text small @click="nuevoForm = false">
                                cancelar
                            </v-btn>
                            <v-btn color="blue" dark small @click="saveData">
                                Guardar cambios
                            </v-btn>
                        </v-card-actions>
                    </v-container>
                </v-form>

            </v-card>
        </v-dialog>

        <!--EditForm-->
        <template>
            <v-row justify="center">
                <v-dialog persistent v-model="editForm" max-width="520">
                    <v-card class="mx-auto">
                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>Editar Usuario</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-form ref="formularioEdicion" class="slim">
                            <v-container class="d-flex pt-6 flex-row flex-wrap ">
                                <v-text-field class="pr-3 mx-240" v-model="user.fldTNombre" label="Nombre" outlined :rules="nameRules" :disabled="puedeCambiar == false" dense></v-text-field>
                                <v-text-field class="pr-3 mx-240" v-model="user.fldTLogin" label="Usuario" outlined :rules="loginRules" :disabled="puedeCambiar == false" dense></v-text-field>
                                <v-text-field class="pr-3 mx-240" v-model="user.fldTEmail" label="Email" :rules="emailRules" outlined :disabled="puedeCambiar == false" dense></v-text-field>
                                <!--Deshabilitamos la rule para el password asi no es requerido-->
                                <v-text-field class="pr-3 mx-240" outlined dense label="Password" type="password" v-model="user.fldTPassword" :disabled="puedeCambiar == false"></v-text-field>
                                <v-autocomplete class="pr-3 mx-240" v-model="user.fkNTipoUsuario" :items="userTypes" item-text="fldTNombre" item-value="idNTipoUsuario"
                                                :disabled="puedeCambiar == false" label="Tipo de Usuario" clearable outlined :rules="usertypeRules" dense></v-autocomplete>
                                <!--No se puede mofificar la relacion con empresa solo la mostramos--->
                                <v-autocomplete class="pr-3 mx-240" v-model="user.idNEmpresa" :items="companies" item-text="fldTNombre" item-value="idNEmpresa"
                                                label="Empresa" disabled="disabled" outlined clearable dense></v-autocomplete>
                                <!--:rules="companyRules" -->
                                <v-row class="ml-5 mt-2 mb-5">
                                    <v-checkbox class="pr-3 mt-n2" label="Activo" v-model="user.fldBActivo" :disabled="puedeCambiar == false" outlined dense></v-checkbox>
                                </v-row>

                                <v-card-actions class="justify-space-between w-100 pb-6">
                                    <v-btn class="ma-2" dark small color="red" @click="deleteItem">
                                        <v-icon left>mdi-delete</v-icon> Borrar registro
                                    </v-btn>
                                    <div class="justify-right">
                                        <v-btn class="ma-2" small color="blue lighten-5" @click="chkBotonCancelar">
                                            Cancelar
                                        </v-btn>
                                        <v-btn v-if="puedeCambiar == false" class="ma-2" dark small color="success" @click="puedeCambiar = true">
                                            <v-icon left>mdi-pencil</v-icon> Editar
                                        </v-btn>
                                        <v-btn v-else class="ma-2" dark small color="success" @click="saveData">
                                            <v-icon left>mdi-pencil</v-icon> Guardar
                                        </v-btn>
                                    </div>
                                </v-card-actions>
                            </v-container>
                        </v-form>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>

        <v-container fluid class="py-0">
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-card>
                        <v-data-table dense :headers="headers" :items="users" :items-per-page="5" :footer-props="{'items-per-page-options': [5, 10, 20, 50]}" class="elevation-1 gt slim">
                            <template v-slot:item.ico1="{ item }">
                                <v-chip :color="item.ico1" dark label></v-chip>
                            </template>
                            <template v-slot:item.fkNTipoUsuario="{ item }">
                                {{getTypeDescription(item.fkNTipoUsuario)}}
                            </template>
                            <template v-slot:item.fldBActivo="{ item }">
                                <v-icon v-if="item.fldBActivo">mdi-check</v-icon>
                                <v-icon v-else>mdi-window-close</v-icon>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-icon color="green" @click="editItem(item)" class="ml-3">
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <template v-slot:item.relation="{ item }">
                                <v-btn text icon @click="redirectToRelaciones(item.idNUsuario)">
                                    <v-icon color="blue">mdi-book-multiple</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <confirm ref="confirmDialog">
        </confirm>
    </div>
</template>

<script>
import {
    Component,
    Prop,
    Vue
} from "vue-property-decorator";
    import UserService from "../services/UserService";
    import CompanyService from "../services/CompanyService";
    import UserCompanyRelationshipService from "../services/UserCompanyRelationshipService";
    import UserModel from "../models/UserModel";
    import Confirm from '../components/ConfirmDelete';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';

@Component({
    components: {
        Confirm
    },
    mounted: async function () {
        // Lo seteamos null ya que por modelo es false
        this.$data.filter.fldBActivo = null;
        await this.loadData();
    },
    methods: {
        loadData: async function () {
            try {
                var resultUsr = await new UserService().list(this.filter);
                if (resultUsr.success) {
                    this.$data.users = resultUsr.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultUsr.Message);
                }  

                var tipos = await new UserService().listTypes();
                this.$data.userTypes = tipos;

                var resultComp = await new CompanyService().list({});
                if (resultComp.success) {
                    this.$data.companies = resultComp.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultComp.Message);
                }

            } catch (e) {
                console.log(e);
            }
        },
        chkfldBActivoFueTrue() {
                if (this.$data.filter.fldBActivo == true) {
                    if (this.$data.fldActivoFueTrue == true) {
                        this.$data.filter.fldBActivo = null;
                        this.$data.fldActivoFueTrue = false;
                    } else {
                        this.$data.fldActivoFueTrue = true;
                    }
                }
        },
         chkBotonCancelar() {
                // Estoy editando y presiono cancelar
                if (this.$data.puedeCambiar == true && this.$data.editForm == true) {
                    this.$data.user = JSON.parse(JSON.stringify(this.$data.userAux));
                    this.$data.puedeCambiar = false;
                } else {
                    this.closeDialog();
                }
        },
        clearFilter: function () {
            this.filter = new UserModel();
            //Reseteamos los contadores usados para manejar el indeterminado
            this.$data.fldBActivoFueTrue = false;
            this.$data.filter.fldBActivo = null;
            this.loadData();
        },
        addUser: function () {
            this.$data.user = new UserModel();
            this.$data.user.fldBActivo = false;
            // Para usar en la seleccion de la empresa
            this.$data.user.idNEmpresa = null;
            this.$data.nuevoForm = true;
        },

        redirectToRelaciones(idNUsuario) {
            let routeData = this.$router.resolve({
                name: 'RelacionesInstalacionesUsuarios',
                params: { id: idNUsuario }
            });
            window.open(routeData.href, '_blank');
        },

        saveData: async function () {
            try {
                var uService = new UserService();
                var data = null;
                if (this.$data.user.idNUsuario) {
                    if (!this.$refs.formularioEdicion.validate()) {
                            return;
                        }
                    data = await uService.update(this.$data.user);
                } else {
                    if (!this.$refs.formularioNuevo.validate()) {
                            return;
                    }
                    data = await uService.insert(this.$data.user);

                }
                if (data.success) {
                        this.nuevoForm = false;
                        this.closeDialog();
                        this.loadData();
                        this.showSuccess('El registro fue guardado correctamente');
                    } else {
                        this.showError('Ocurrio un error al guardar el registro: ' + data.error);
                    }
            } catch (e) {
                console.log(e);
            }
        },
        getTypeDescription(id) {
            let desc = this.userTypes.find(function (e) {
                return e.idNTipoUsuario == id;
            });
            if (desc)
                return desc.fldTNombre;
            return id;
        },
        getCompanyDescription(id) {
            //TODO
        },
        closeDialog() {
            this.editForm = false;
            this.puedeCambiar = false;
            this.alert = false;
            this.$data.user = new UserModel();
            this.$data.userAux = new UserModel();
        },
        async editItem(item) {
            this.$data.user = JSON.parse(JSON.stringify(item));
            this.$data.userAux = JSON.parse(JSON.stringify(item));
            // Buscamos la relacion con Empresa
            var rue = await new UserCompanyRelationshipService().getByUser(this.$data.user.idNUsuario);
            if (rue.data[0]) {
                this.$data.user.idNEmpresa = rue.data[0].fkNEmpresa;
                this.$data.userAux.idNEmpresa = rue.data[0].fkNEmpresa;
            }
            this.$data.editForm = true;
        },
        async deleteItem() {
             var ret = await this.$refs.confirmDialog.showDialog();
                if (ret == true) {
                    var data = await new UserService().delete(this.$data.user);
                    if (data.success) {
                        this.closeDialog();
                        this.showSuccess('El registro fue eliminado correctamente');
                        this.loadData();
                    } else {
                        this.showError('Ocurrio un error borrando el registro: ' + data.error);
                    }
                 }
        },
        async exportExcel() {
            var data = await new UserService().export(this.filter);
            var fileURL = window.URL.createObjectURL(data);
            var fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'usuarios.xlsx');
            document.body.appendChild(fileLink);

            fileLink.click();
        },
        exportPDF() {
                var doc = new jsPDF({ orientation: 'landscape' });
                var title = 'Usuarios';
                var columns = [
                    { title: 'Nombre', dataKey: 'fldTNombre' },
                    { title: 'Usuario', dataKey: 'fldTLogin' },
                    { title: 'Email', dataKey: 'fldTEmail' },
                    { title: 'Tipo', dataKey: 'fkNTipoUsuario' },
                    { title: 'Activo', dataKey: 'fldBActivo' },
                ];
                // Customizar columnas
            doc.text(title, 15, 15);
            var self = this;
                var data = JSON.parse(JSON.stringify(this.$data.users));
                    data.forEach(function (d) {
                        d.fkNTipoUsuario = self.getTypeDescription(d.fkNTipoUsuario);
                        d.fldBActivo = d.fldBActivo == true ? "SI" : "NO";
                    });
                doc.autoTable(columns, data, { margin: { top: 20 } })
                doc.save(title + '.pdf');
            }
    },
    computed: {
        /*passwordRules: function () {
            let rules = [];
            if (!this.user.idNUsuario)
                rules.push(v => !!v || 'Debe ingresar una contraseña');
            rules.push(v => v.length <= 250 || 'La contraseña tiene que contener menos de 250 caracteres');

            return rules;
        }*/
    }
})
export default class Usuarios extends Vue {    

    nuevoForm = false;
    editForm = false;
    puedeCambiar = false;
    formularioNuevo = true;
    formularioEdicion = true;
    alert = false;

    // Para Indeterminados
    fldBActivoFueTrue = false;

    // Modelos
    user = new UserModel();
    userAux = new UserModel();
    filter = new UserModel();
    

    // Listas
    users = [];
    userTypes = [];
    companies = [];

    
    headers = [
        {
            text: '',
            value: 'ico1',
            sortable: false,
            width: 10
        },{
            text: '',
            value: 'action',
            sortable: false
        },{
            text: '',
            value: 'relation',
            sortable: false
        },
        {
            text: 'Nombre',
            value: 'fldTNombre'
        },
        {
            text: 'Usuario',
            value: 'fldTLogin'
        },
        {
            text: 'Email',
            value: 'fldTEmail'
        },
        {
            text: 'Tipo Usuario',
            value: 'fkNTipoUsuario'
        },
        {
            text: 'Activo',
            value: 'fldBActivo'
        },
    ];
    passwordRules = [
        v => !!v || 'Debe ingresar un password',
        v => v && v.length >= 6 || 'El password tiene que contener al menos 6 caracteres',
    ];
    nameRules = [
        v => !!v || 'Debe ingresar un nombre',
        v => v && v.length <= 250 || 'El nombre tiene que contener menos de 250 caracteres',
    ];
    loginRules = [
        v => !!v || 'Debe ingresar un usuario',
        v => v && v.length <= 250 || 'El usuario tiene que contener menos de 250 caracteres',
    ];
    emailRules = [
        v => !!v || 'Debe ingresar un email',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El email ingresado es incorrecto'
    ];
    usertypeRules = [
        v => !!v || 'Debe seleccionar un tipo de usuario',
    ];
    companyRules = [
        v => !!v || 'Debe seleccionar una Empresa',
    ];
}
</script>
